import { EmailMessagingStatus } from '@/modules/auth/constants'
import { create } from 'zustand'

export enum EmailFieldStatus {
  Called = 'called',
}

export interface EmailFieldStore {
  emailFieldStatus: EmailFieldStatus | null
  setEmailFieldStatus: (status: EmailFieldStatus | null) => void
  emailVerificationStatus: EmailMessagingStatus | null
  setEmailVerificationStatus: (status: EmailMessagingStatus | null) => void
}

export const useEmailFieldStore = create<EmailFieldStore>((set) => ({
  emailFieldStatus: null,
  setEmailFieldStatus: (emailFieldStatus: EmailFieldStatus | null) =>
    set(() => ({ emailFieldStatus })),
  emailVerificationStatus: null,
  setEmailVerificationStatus: (
    emailVerificationStatus: EmailMessagingStatus | null,
  ) => set(() => ({ emailVerificationStatus })),
}))
